import React from "react";
import {Navigate} from "react-router-dom";
import {useAuth} from "features/login/context/AuthProvider";

function AuthRouteComponent({
                                children,
                            }: any) {
    const {authenticated, isChecking} = useAuth();

    if (isChecking) {
        return null;
    }

    if (authenticated) {
        return (
            <Navigate to="/box/plan" replace/>
        );
    }
    return children;
}

export default AuthRouteComponent;
